import { useTheme } from "@mui/material/styles";
import { Pill } from "@src/appV2/redesign/system/ui-components";

import { type PaymentsListItem } from "../types/PaymentsListItem";
import {
  getPayoutStatusBackgroundColor,
  getPayoutStatusColor,
  getPayoutStatusIcon,
  getPayoutStatusText,
} from "../utils/payoutStatusDisplay";

export interface PaymentsListItemPillProps {
  item: PaymentsListItem;
  /** Whether to reduce the Pill's height
   * Default: `true`
   */
  compact?: boolean;
}

export function PaymentsListItemPill(props: PaymentsListItemPillProps) {
  const { compact = true, item } = props;
  const theme = useTheme();
  const iconType = getPayoutStatusIcon(item);
  const iconColor = getPayoutStatusColor(theme, item);

  return (
    <Pill
      variant="filled"
      size="small"
      backgroundColor={(theme) => getPayoutStatusBackgroundColor(theme, item)}
      color={(theme) => getPayoutStatusColor(theme, item)}
      label={getPayoutStatusText(item)}
      iconType={iconType}
      iconColor={(_) => iconColor}
      sx={(theme) => ({
        height: compact ? theme.spacing(6) : undefined,
        minHeight: compact ? theme.spacing(6) : undefined,
        paddingX: theme.spacing(1),
        "& .MuiSvgIcon-root": {
          width: theme.spacing(4),
          height: theme.spacing(4),
          marginLeft: theme.spacing(1),
        },
      })}
    />
  );
}
